import { MutationCache, QueryClient } from '@tanstack/react-query';
import { createRouter as createTanStackRouter } from '@tanstack/react-router';
import { getFeatureGateFeature } from './lib/feature-gate-client';
import { routeTree } from './routeTree.gen';

export function getRouter() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000,
      },
    },
    // Global interceptor: when any mutation fails with a FEATURE_GATE
    // response from the server, route the user to /pricing with the
    // feature name as a query param so the upgrade modal can render the
    // right copy. The original mutation's per-site onError still runs
    // afterwards — this doesn't short-circuit React Query's normal flow.
    mutationCache: new MutationCache({
      onError: (error) => {
        if (typeof window === 'undefined') return;
        const feature = getFeatureGateFeature(error);
        if (!feature) return;
        window.location.assign(`/pricing?limit=${encodeURIComponent(feature)}`);
      },
    }),
  });

  const router = createTanStackRouter({
    routeTree,
    scrollRestoration: true,
    defaultPreload: 'intent',
    context: { queryClient },
  });

  return router;
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof getRouter>;
  }
}
